// extracted by mini-css-extract-plugin
export default {"section-title":"style_section-title__PhfYL","section-title2":"style_section-title2__ER+Jl"};